import { logout as authLogout } from '@carrier-sce-sharedpackages/reactauthwrapper';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  Popover,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { PECR_VERSION_NUMBER } from 'constants/pecrConstants';
import { appConfig } from '../../appConfig';
import LanguageChange from '../../i18n/languageChange';
import { clearNotification } from '../../reducers/handle-api-status/slice';
import { clearOverviewData } from '../../reducers/overview/slice';
import { clearResourceModificationData } from '../../reducers/resource-modification-data/slice';
import {
  boldFont,
  SiteReviewValue,
  tableSection,
  whiteColor,
} from '../../styles';
import { isEmptyObject } from '../../utils';
import {
  logoutCard,
  logoutGrid,
  logoutIconStyle,
  userNameGrid,
} from './navStyle';

// Logout component to handle logout functionality
const Logout = props => {
  const { userInfo } = props;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);

  /* To change the language of the appliaction as saved by User last time */
  useEffect(() => {
    if (!isEmptyObject(userInfo)) {
      i18n.changeLanguage(userInfo.language);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  //To open the logout card
  const openPopover = event => {
    setAnchorEl(event.currentTarget);
  };

  //To close the logout card
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  //To logout from the application and to clear some redux states
  const onLogoutClick = () => {
    dispatch(clearOverviewData({}));
    dispatch(clearNotification({}));
    dispatch(clearResourceModificationData([]));
    authLogout(appConfig);
  };

  return (
    <Grid style={logoutGrid}>
      <IconButton onClick={openPopover}>
        <SettingsIcon style={whiteColor} />
      </IconButton>
      <Popover
        id={'setting-popover'}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: -235,
        }}
        disableScrollLock
        elevation={0}
      >
        <Card style={logoutCard}>
          <CardContent>
            <Grid style={userNameGrid}>{userInfo?.name}</Grid>
            <Grid style={tableSection}>
              <Grid style={boldFont}>{t('Site')}:</Grid>
              <Grid style={SiteReviewValue}>{userInfo?.siteName}</Grid>
            </Grid>
            <Grid style={tableSection}>
              <Grid style={boldFont}>{t('Language')}:</Grid>
              <Grid style={SiteReviewValue}>
                <LanguageChange />
              </Grid>
            </Grid>
            <CardActions style={tableSection}>
              <IconButton sx={logoutIconStyle} onClick={onLogoutClick}>
                <LogoutIcon /> <span>{t('Logout')}</span>
              </IconButton>
            </CardActions>
            <div className="text-center font-bold underline">{`Version: ${PECR_VERSION_NUMBER}`}</div>
          </CardContent>
        </Card>
      </Popover>
    </Grid>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
  };
};

export default connect(mapStateToProps, null)(Logout);
